(() => {
  /**
   * Handle the boost modifier
   */
  class BoostModifier extends PIXI.Container {
    constructor() {
      super();

      this._ballSprite = null;
      this._boostBallEmitter = null;
      this.tempAnims = [];
      this.tempSprites = [];
      this.tempEmitters = [];
      this.shootingEmitterPool = [];
      this.shootingEmitterPoolLength = 0;
      this.explodingEffectPool = [];
      this.explodingEffectPoolLength = 0;
      this.shootingSpritePool = [];
      this.shootingSpritePoolLength = 0;

      Reflex.registerEventHandler("orientationChange", this._orientationChange.bind(this));
    }

    delay = (ms) => new Promise((res) => setTimeout(res, ms));

    /**
     * Initialise the class
     */
    initialise() {
      this._ballSprite = resourceManager.get("boostModifier:boostBall");

      gsap.to(this._ballSprite, {
        duration: 3,
        rotation: Math.PI * 2,
        repeat: -1,
        ease: "linear",
      });
      // this.rotateTween.time(0).restart(true);

      this._boostBallEmitter = particleManager.createEmitter(
        "throwParticleGreen",
        "boostModifier:boostModifierContainer",
        0,
        -125,
        false
      );
      this._boostBallEmitter.particleEmitter.spawnPos = { x: 0, y: 0 };
      this._boostBallEmitter.visible = false;
      this._boostBallEmitter.particleEmitter.emit = false;
    }

    /**
     * Grab the devil character spine assets
     */
    _onLayoutComplete() {}

    /**
     * Start the boost modifier
     */
    async start() {
      //show boostBall and switch centreDevil to fireball intro
      gameController.centreDevil.fireBallIntro();
      this._ballSprite.visible = true;
      this._boostBallEmitter.visible = true;
      this._boostBallEmitter.particleEmitter.emit = true;
      await this.delay(1000);

      //create temp sprites and emitters
      for (let i = 0; i < gameController.boostModifier.boostedCollectables.length; i++) {
        const reel = helper.convertReelRowToIndex(
          gameController.boostModifier.boostedCollectables[i].coord.reel,
          gameController.boostModifier.boostedCollectables[i].coord.row
        );
        //get new symbolId for gem/coin
        const symID = this.getSymbolID(gameController.boostModifier.boostedCollectables[i]);

        const shootingEmitter = this.getEmitterFromPool();
        this.tempEmitters.push(shootingEmitter);
        const shootingSprite = this.getShootingSpriteFromPool();
        this.tempSprites.push(shootingSprite);
        if(i === gameController.boostModifier.boostedCollectables.length -1){
          this._boostBallEmitter.particleEmitter.emit = false;
          this._boostBallEmitter.visible = false;
          this._ballSprite.visible = false;  
          gameController.centreDevil.idleLoop(); 
         }
        await this.shootParticleTween(shootingEmitter, reel, shootingSprite, symID);
      }

      await new Promise(res => gsap.delayedCall(1, res));
      //timerManager.addTimeout(1000, () => {
        this._reset();
        gameController.modifierComplete = true;
      //});
    }

    getSymbolID(collectable) {
      if (collectable.type === "Gem") {
        switch (collectable.potName) {
          case "Mini":
            return 8;
          case "Minor":
            return 9;
          case "Major":
            return 10;
          case "Grand":
            return 11;
        }
      }
    }

    async shootParticleTween(emitter, reel, sprite, symID) {
      return new Promise((resolve) => {
        const target = (obj) => {
          const globalPos = resourceManager.get(`slotContainer:reelContainer:reel${reel}:symbol0`).getGlobalPosition();
          const localPos = obj.parent.toLocal(globalPos);
          return { x: localPos.x, y: localPos.y };
        };
        const emitterTarget = target(emitter);
        const spriteTarget = target(sprite);

        const duration = 0.6;

        const explodingEffectAnim = this.getExplodingEffectAnimFromPool();
        explodingEffectAnim.anim.x = spriteTarget.x;
        explodingEffectAnim.anim.y = spriteTarget.y;
        explodingEffectAnim.anim.visible = true;
        explodingEffectAnim.anim.gotoAndStop(0);
        explodingEffectAnim.anim.onComplete = function () {
          explodingEffectAnim.anim.visible = false;
        };
        explodingEffectAnim.anim.onFrameChange = (frameNum) => {
          if (frameNum === 10) {
            gameController.convertedReelResults[reel][0] = symID;
            const reelObj = resourceManager.get("slotContainer:reelContainer:reel" + reel);
            reelObj.setReelSymbol(0, symID);
          }
        };
        this.tempAnims.push(explodingEffectAnim);

        soundManager.stop("orbLoop");
        soundManager.play("orbWhoosh");
        gsap
          .timeline()
          .call(() => {
            emitter.x = 0;
            emitter.y = -125;
            emitter.particleEmitter.emit = true;
            emitter.visible = true;
          })
          .to(emitter, {
            duration,
            ease: "linear",
            y: emitterTarget.y,
          })
          .to(
            emitter,
            {
              duration,
              ease: "linear",
              x: emitterTarget.x,
              onComplete: () => {
                emitter.particleEmitter.emit = false;
                emitter.visible = false;
                resolve();
              },
            },
            "<"
          );
        gsap
          .timeline()
          .call(() => {
            sprite.visible = true;
            sprite.x = 0;
            sprite.y = -125;
          })
          .to(sprite, {
            duration,
            ease: "linear",
            y: spriteTarget.y,
          })
          .to(
            sprite,
            {
              duration,
              ease: "linear",
              x: spriteTarget.x,
              onComplete: () => {
                sprite.visible = false;
                soundManager.play("orbLand");
                explodingEffectAnim.anim.play();
              },
            },
            "<"
          );
      });
    }

    /**
     * Fetch an exploding anim from the pool or create a new one
     */
    getExplodingEffectAnimFromPool = function () {
      let explosion = undefined;

      if (this.explodingEffectPool.length > 0) {
        explosion = this.explodingEffectPool.pop();
      } else {
        this.createExplodingEffectAnim();
        explosion = this.explodingEffectPool.pop();
      }
      return explosion;
    };

    /**
     * Fetch a shooting sprite from the pool or create a new one
     */
    getShootingSpriteFromPool = function () {
      let shootingSprite = undefined;

      if (this.shootingSpritePool.length > 0) {
        shootingSprite = this.shootingSpritePool.pop();
      } else {
        this.createShootingSprite();
        shootingSprite = this.shootingSpritePool.pop();
      }
      return shootingSprite;
    };

    /**
     * Fetch an emitter from the pool or create a new one
     */
    getEmitterFromPool = function () {
      let shootingEmitter = undefined;

      if (this.shootingEmitterPool.length > 0) {
        shootingEmitter = this.shootingEmitterPool.pop();
      } else {
        this.createShootingEmitter();
        shootingEmitter = this.shootingEmitterPool.pop();
      }
      return shootingEmitter;
    };

    /**
     * Create exploding effect anim
     */
    createExplodingEffectAnim() {
      let explodingEffectAnim = resourceManager.createObject(
        "movie",
        `explosionEffectAnim${this.explodingEffectPoolLength}`,
        "boostModifier:boostModifierContainer",
        {
          definition: "explosionEffect",
          x: 0,
          y: 0,
          anchor: 0.5,
          scale: 0.8,
          loop: false,
          onComplete: function () {},
        }
      );

      explodingEffectAnim.visible = true;
      explodingEffectAnim.alpha = 1;
      this.explodingEffectPoolLength++;

      this.explodingEffectPool.push({
        number: this.explodingEffectPool.length,
        anim: explodingEffectAnim,
      });
    }

    /**
     * Create a shooting emitter
     */
    createShootingEmitter() {
      const emitter = particleManager.createEmitter(
        "throwParticleGreen",
        "boostModifier:boostModifierContainer",
        0,
        -125,
        false
      );
      emitter.particleEmitter.spawnPos = { x: 0, y: 0 };
      emitter.particleEmitter.emit = true;
      emitter.visible = true;
      this.shootingEmitterPool.push(emitter);
    }

    /**
     * Create a shooting sprite.
     */
    createShootingSprite() {
      const shootingSprite = resourceManager.createObject(
        "sprite",
        "shootingSprite" + this.shootingSpritePoolLength,
        "boostModifier:boostModifierContainer",
        {
          fileName: "Symbols/Devil Symbols/Boost Fireball/Green_Fireball_0000.png",
          anchor: 0.5,
          x: 0,
          y: -125,
          scale: 1,
          visible: true,
        }
      );
      this.shootingSpritePoolLength++;

      this.rotateTween = gsap.to(shootingSprite, {
        duration: 3,
        rotation: Math.PI * 2,
        repeat: -1,
        ease: "linear",
      });
      this.rotateTween.time(0).restart(true);

      this.shootingSpritePool.push(shootingSprite);
    }

    /**
     * Reset all state
     */
    _reset() {
      this._ballSprite.visible = false;
      this._boostBallEmitter.particleEmitter.emit = false;
      this._boostBallEmitter.visible = false;

      this.tempEmitters.forEach((anim) => {
        this.shootingEmitterPool.push(anim);
      });
      while (this.tempEmitters.length) {
        this.tempEmitters.shift();
      }

      this.tempAnims.forEach((anim) => {
        this.explodingEffectPool.push(anim);
      });
      while (this.tempAnims.length) {
        this.tempAnims.shift();
      }

      this.tempSprites.forEach((sprite) => {
        this.shootingSpritePool.push(sprite);
      });
      while (this.tempSprites.length) {
        this.tempSprites.shift();
      }
    }

    /**
     * Handle orientation change
     * @param {boolean} isLandscape
     */
    _orientationChange(isLandscape) {}
  }

  resourceManager.registerObjectType(
    "boostModifier",
    () => new BoostModifier(),
    () => {},
    () => []
  );
})();
